import { JOINT_CLIENT_HOLDING_PATTERNS } from "creso-core/constants";
import { ClientHoldingPattern } from "creso-core/types";
import { Badge, cn } from "web-design-system";

export const HoldingPatternBadge = ({
  holdingPattern,
  className,
}: {
  holdingPattern: ClientHoldingPattern;
  className?: string;
}) => {
  const holdingPatternLabel = holdingPattern === "single" ? "Single" : "Joint";
  return (
    <Badge
      variant="custom"
      className={cn(
        "text-xs w-fit",
        holdingPattern === "single" &&
          "bg-tag-orange text-tag-orange-foreground",
        JOINT_CLIENT_HOLDING_PATTERNS.includes(holdingPattern) &&
          "bg-tag-blue text-tag-blue-foreground",
        className
      )}
    >
      {holdingPatternLabel}
    </Badge>
  );
};
